import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useState} from 'react';
import 'react-vertical-timeline-component/style.min.css';
import {BillView} from "../../inventory/billing/BillView";
import axios from "axios";

export const PatientBillView = forwardRef((props: { entityQr: string, qrCode: string, uhid: string, qId: string }, ref) => {

    const [billId, setBillId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [customerData, setCustomerData] = useState(null);

    const handlePostAction = (billId) => {
        axios.post('/api/backend/customer/data/save/' + props.uhid + '/' + props.qrCode + "?qId=" + props.qId, {
            ...customerData,
            billId: billId
        })
            .then(resp => {
                console.info(JSON.parse(resp.data))
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            });

    }

    useEffect(() => {
        if (props.qrCode && props.uhid) {
            if (props.qId) {
                axios.get('/api/backend/customer/data/fetch/' + props.uhid + '/' + props.qId)
                    .then(resp => {
                        console.log(JSON.stringify(resp.data))
                        setBillId(resp.data.billId)
                        setCustomerData(resp.data)
                    })
                    .catch(err => {
                        console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    })
            } else {
                axios.get('/api/backend/customer/data/fetch/latest/' + props.qrCode + '/' + props.uhid)
                    .then(resp => {
                        console.log(JSON.stringify(resp.data))
                        setBillId(resp.data.billId)
                        setCustomerData(resp.data)
                    })
                    .catch(err => {
                        console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                    })
            }
            axios.get('/api/backend/customers/fetch/' + props.uhid)
                .then(resp1 => {
                    console.log(JSON.stringify(resp1.data))
                    axios.get('/api/backend/inventory/customer/fetch/' + props.entityQr + "?name=" + resp1.data.name + "&contact=" + resp1.data.mobile)
                        .then(resp => {
                            console.log(JSON.stringify(resp.data))
                            setCustomerId(resp.data.id)
                        })
                        .catch(err => {
                            console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                            axios.post('/api/backend/inventory/customer/create', {
                                entityQr: props.entityQr,
                                type: "INDIVIDUAL",
                                name: resp1.data.name,
                                displayName: resp1.data.name,
                                contact1: resp1.data.mobile
                            })
                                .then(resp => {
                                    console.log(JSON.stringify(resp.data))
                                    setCustomerId(resp.data.id)
                                })
                                .catch(err => {
                                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                                })
                        })
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        }
    }, [props.qrCode, props.uhid])


    return (
        <>
            {customerId && <BillView billId={billId} customerId={customerId}
                      entityQr={props.entityQr} postAction={handlePostAction} source={"OPD"}/>}
        </>
    );
});

PatientBillView.displayName = "PatientBillView";